import React from 'react';
import { createRoot } from 'react-dom/client';
import * as qs from 'qs';
import styleProcessor from 'wix-style-processor';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import { win } from '@wix/cashier-common/dist/src/utils/win';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { WalletApp } from './components/App';
import { ErrorBoundary } from './components/App/elements/ErrorBoundary';
import { globals } from './utils/globals';
import { inIframe } from './utils/inIframe';
import { wixSdkAdapter } from './utils/wixSdkAdapter';

// during the development we need to simulate post message from the parent window (Editor/Viewer) with site styles
if (process.env.NODE_ENV === 'development' && !inIframe()) {
  wixSdkAdapter.Wix.Utils.getViewMode = () => 'site';
  const tpaResponse = require('../test/mocks/fakeTPAInitResponse.json');
  win.postMessage(JSON.stringify(tpaResponse), '*');
}

experimentsService.init(globals.experiments || {});

styleProcessor.init();

interface IWalletParams {
  deviceType: DeviceType;
  locale: string;
  lang?: string;
}

const params: IWalletParams = qs.parse(location.search.slice(1)) as any;
const locale: string = globals.locale;

if (locale) {
  document.body.setAttribute('lang', locale);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <WalletApp
      viewMode={wixSdkAdapter.getViewMode()}
      locale={locale}
      staticsBaseUrl={globals.staticsBaseUrl}
      deviceType={params.deviceType}
    />
  </ErrorBoundary>,
);
